import { Component, OnInit, Input, ChangeDetectorRef, Output, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, Validators, FormArray, UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ECalendarValue, IDatePickerConfig, } from 'ng2-date-picker';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ToastrService } from 'ngx-toastr';
import { TimeslotPickerService } from './timeslot-picker-new.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgIf, NgFor, NgClass, DatePipe } from '@angular/common';
import { SingleDateInlinePickerComponent } from '../../booking-tabs/single-date-inlinePicker/single-date-inlinePicker.component';

@Component({
    selector: 'app-timeslot-picker-new',
    templateUrl: './timeslot-picker-new.component.html',
    styleUrls: ['./timeslot-picker-new.component.scss'],
    standalone: true,
    imports: [
        SingleDateInlinePickerComponent,
        NgIf,
        NgFor,
        NgClass,
        ExtendedModule,
        FlexModule,
        MatButtonModule,
        MatIconModule,
        DatePipe,
        TranslateModule,
    ],
})
export class TimeslotPickerNewComponent implements OnInit, AfterViewInit {
    constructor( private fb: UntypedFormBuilder, private timeslotService: TimeslotPickerService, private toastr: ToastrService) {
    }

    ngOnInit(): void {}

    selectedYearMonth;

    selectedDay;

    //selectedTimeslots = [];

    ngAfterViewInit(): void {
         this.form.get('date')?.valueChanges.subscribe((value)=>{
            if(value && value != '')
            //this.selectYearMonth(value);
            this.selectDay(value);
            else{
            this.timeslots = [];
            if(!this.form.get('timeslots'))
            this.form.addControl('timeslots', this.fb.control([]))
            }
            if (!this.form.get('timeslots')?.value) this.form.get('timeslots')?.setValue([]);
        });
        if(!this.form.get('timeslots'))
        this.form.addControl('timeslots', this.fb.control([]))
    }

    @Input() form: UntypedFormGroup;
    @Input() product;





selectDay(selected){
    if (this.product.serviceType != 'day' || !this.product.serviceTimeSelection) return;
    this.selectedDay = selected;
    this.timeslots = null;
    let toDate = new Date(selected);
    this.timeslotService.getTimeslots(this.product._id, toDate.toLocaleDateString('en-CA')).subscribe((response)=>{
        if(response.code == 200 && response.data)
        this.timeslots = response.data;
    },(error)=>{
        console.log(error);
        this.toastr.error('Error getting Timeslots.')
    });
}

addRemoveTimeslot(selected){
    let index = this.form.get('timeslots')?.value?.findIndex((timeslot)=>{
       return selected.start == timeslot.start && selected.end == timeslot.end;
    });

    if(index > -1){
         this.form.get('timeslots')?.value?.splice(index, 1);
    }else{
         this.form.get('timeslots')?.value?.push(selected);
    }

   /*  if(index != -1){
    this.form.get('timeslots')?.value?.splice(index, 1);
    }else{
        this.form.get('timeslots')?.value?.push(selected);
    } */

}
isSelected(timeslot){
    let index = this.form.get('timeslots')?.value?.findIndex((item)=>{
       return timeslot.start == item.start && timeslot.end == item.end;
    });
    //if (!index) return false
    return index > -1? true : false;
}


removeTimeslot(selected){
    this.form.get('timeslots')?.value?.splice(this.form.get('timeslots')?.value?.indexOf(selected), 1);
}

days;

timeslots;


    carouselOptionsTimeslot: any = {
        items:7,
        skip_validateItems: true,
        nav: false,
        dots: false,
        loop: false,
        responsive: {
            1100: { items: 8 },
            920: { items: 7 },
            680: { items: 6 },
            500: { items: 5 },
            0: { items: 2 }
        },
    };

    customOptions: OwlOptions = {
        loop: true,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        dots: false,
        navSpeed: 700,
        navText: ['', ''],
        responsive: {
          0: {
            items: 2
          },
          400: {
            items: 2
          },
          740: {
            items: 3
          },
          940: {
            items: 4
          }
        },
        nav: true
      }

}
